import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getAll,
  getId,
  createItem,
  updateItem,
  deleteById,
  getAllPolicy,
  getIdPolicy,
  updateItemPolicy,
  getPrivacy,
  updateItemPrivacy,
  createItemApk,
} from "./settingAPI";

const initialState = {
  data: [],
  data3: [],
  data2: [],
  dataId: null,
  dataId2: null,
  dataId3: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
};

export const fetchData = createAsyncThunk(
  "setting/fetchData",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);
export const fetchDataPrivacy = createAsyncThunk(
  "setting/fetchDataPrivacy",
  async (payload) => {
    const response = await getPrivacy(payload);
    return response;
  }
);
export const fetchDataPolicy = createAsyncThunk(
  "setting/fetchDataPolicy",
  async (payload) => {
    const response = await getAllPolicy(payload);
    return response;
  }
);

export const fetchSetting = createAsyncThunk(
  "setting/fetchSetting",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);

export const fetchId = createAsyncThunk("setting/fetchId", async (id) => {
  const response = await getId(id);
  return response;
});
export const fetchIdPolicy = createAsyncThunk(
  "setting/fetchIdPolicy",
  async (id) => {
    const response = await getIdPolicy(id);
    return response;
  }
);
export const fetchIdNoloading = createAsyncThunk(
  "setting/fetchIdNoloading",
  async (id) => {
    const response = await getId(id);
    return response;
  }
);
export const fetchIdNoPolicyloading = createAsyncThunk(
  "setting/fetchIdNoPolicyloading",
  async (id) => {
    const response = await getIdPolicy(id);
    return response;
  }
);
export const addItem = createAsyncThunk("setting/addItem", async (payload) => {
  const response = await createItem(payload);
  return response;
});

export const editItem = createAsyncThunk(
  "setting/editItem",
  async (payload) => {
    const response = await updateItem(payload);
    return response;
  }
);
export const editItemPrivacy = createAsyncThunk(
  "setting/editItemPrivacy",
  async (payload) => {
    const response = await updateItemPrivacy(payload);
    return response;
  }
);
export const editItemPolicy = createAsyncThunk(
  "setting/editItemPolicy",
  async (payload) => {
    const response = await updateItemPolicy(payload);
    return response;
  }
);
export const removeById = createAsyncThunk(
  "setting/removeById",
  async (payload) => {
    const response = await deleteById(payload);
    return response;
  }
);

export const addItemApk = createAsyncThunk(
  "company/addItemApk",
  async ({ payload, file }) => {
    console.log(payload, "payload slice");
    const response = await createItemApk(payload, file);
    return response;
  }
);

export const settingSlice = createSlice({
  name: "setting",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchDataPolicy.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDataPolicy.fulfilled, (state, action) => {
        state.loading = false;
        state.data2 = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchSetting.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchSetting.fulfilled, (state, action) => {
        state.loading = false;
        state.data3 = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchId.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchId.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(fetchDataPrivacy.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDataPrivacy.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId3 = action.payload.data.data;
      })
      .addCase(fetchIdPolicy.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdPolicy.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId2 = action.payload.data.data;
      })
      .addCase(fetchIdNoloading.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchIdNoloading.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(fetchIdNoPolicyloading.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchIdNoPolicyloading.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(addItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(addItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(editItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editItemPolicy.pending, (state) => {
        state.loading = true;
      })
      .addCase(editItemPolicy.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editItemPrivacy.pending, (state) => {
        state.loading = true;
      })
      .addCase(editItemPrivacy.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeById.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeById.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(addItemApk.pending, (state) => {
        state.loading = true;
      })
      .addCase(addItemApk.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const { resetData, setSelected } = settingSlice.actions;

export const selectData = (state) => state.setting.data;
export const selectDataPolicy = (state) => state.setting.data2;
export const selectSetting = (state) => state.setting.data3;
export const selectId = (state) => state.setting.dataId;
export const selectIdPolicy = (state) => state.setting.dataId2;
export const selectIdPrivacy = (state) => state.setting.dataId3;
export const selectLoading = (state) => state.setting.loading;
export const selectError = (state) => state.setting.error;
export const selectPageNo = (state) => state.setting.pageNo;
export const selectPageSize = (state) => state.setting.pageSize;
export const selectTotalRecord = (state) => state.setting.totalRecord;
export const selectSelected = (state) => state.setting.selected;
export const selectResult = (state) => state.setting.result;

export default settingSlice.reducer;
